import {useCallback, useEffect, useMemo} from 'react';

import {useOktaAuth} from '@okta/okta-react';
import {TIMERS_IDS} from 'src/modules/updater/constants';
import UpdatesChecker from 'src/modules/updater/utils/updatesChecker';
import {getAllAttributeRelationInfo, getUniqueAttributeTitleCount} from 'src/openapi/apis/AttributeControllerApi';
import {getAllChangeRequests, getChangeRequestCount} from 'src/openapi/apis/ChangeRequestControllerApi';
import {getAllEvents, getEventCount} from 'src/openapi/apis/EventControllerApi';
import {getCurrentUser} from 'src/openapi/apis/UserControllerApi';
import {useAppDispatch} from 'src/store';

const UpdaterController = () => {
    const {oktaAuth, authState} = useOktaAuth();
    const dispatch = useAppDispatch();
    const updateChecker = useMemo(() => new UpdatesChecker(), []);

    useEffect(() => {
        if (authState?.isAuthenticated) {
            dispatch(getCurrentUser());
        }
    }, [authState?.isAuthenticated, dispatch]);

    useEffect(() => {
        const handleTokenChange = () => {
            dispatch(getCurrentUser());
        };

        oktaAuth.tokenManager.on('added', handleTokenChange);
        oktaAuth.tokenManager.on('renewed', handleTokenChange);

        return () => {
            oktaAuth.tokenManager.off('added', handleTokenChange);
            oktaAuth.tokenManager.off('renewed', handleTokenChange);
        };
    }, [dispatch, oktaAuth]);

    const updateAllEvents = useCallback(() => {
        dispatch(getEventCount());
        dispatch(getAllEvents());
    }, [dispatch]);

    const updateAllAttributes = useCallback(() => {
        dispatch(getUniqueAttributeTitleCount());
        dispatch(getAllAttributeRelationInfo());
    }, [dispatch]);

    const updateChangeRequests = useCallback(() => {
        dispatch(getAllChangeRequests());
        dispatch(getChangeRequestCount());
    }, [dispatch]);

    useEffect(() => {
        updateChecker.subscribe(TIMERS_IDS.ALL_EVENTS, updateAllEvents);
        updateChecker.subscribe(TIMERS_IDS.ALL_ATTRIBUTES, updateAllAttributes);
        updateChecker.subscribe(TIMERS_IDS.ALL_CHANGE_REQUESTS, updateChangeRequests);
        return () => {
            updateChecker.unSubscribe(TIMERS_IDS.ALL_EVENTS);
            updateChecker.unSubscribe(TIMERS_IDS.ALL_ATTRIBUTES);
            updateChecker.unSubscribe(TIMERS_IDS.ALL_CHANGE_REQUESTS);
        };
    }, [updateAllAttributes, updateAllEvents, updateChangeRequests, updateChecker]);
    return null;
};

export default UpdaterController;
